












































































































































































































































































































































































































import Vue from 'vue';
import Upload from '@/components/Upload.vue';
import UploadList from '@/components/UploadList.vue';
import SnapshotList from '@/components/embed/SnapshotList.vue';
import { IsEmbedded } from '@/constants/environment';
import store from '@/store/store';
import ShareLinkModal from '@/components/embed/ShareLinkModal.vue';
import SupportForm from '@/components/support/SupportForm.vue';
import { BvModalEvent } from 'bootstrap-vue';
import TimelineSurveyPopup from '@/components/user_questions/TimelineSurveyPopup.vue';

export default Vue.extend(
    {
        name: 'CliovisNavbar',
        components: 
	{
	    // Hack to get JS component to work in TS
	    Upload: (Upload as any),
	    TimelineSurveyPopup,
	    UploadList,
	    SnapshotList,
	    ShareLinkModal,
	    SupportForm
	},
        data()
        {
            return {
                exitProject: {
                    text: "",
                    callback: ()=>
                    {}
                },
                modalKey: 0
            };
        },
        computed:{
            isEmbedded()
            {
                if (IsEmbedded) return true;

                // This bit of absolute stupidity is the only way I can get it to not break the typescript compiler
                let route : any = this.$route;
                let path : any = route.fullPath;
                let incl : any = path.includes('app/e/');
                return incl;
            },
            isLTI()
            {
                return store.state.isLTI;
            },
            timeline()
            {
                return this.$store.state.project.activeTimeline;
            }
        },
        watch: 
	{
	    "$route"()
	    {
	        this.$nextTick(() =>
	        {
	            this.$recompute('seenGetStartedTooltip');
	            this.$recompute('navItems');
	            this.$recompute('additionalItems');
	            this.$forceUpdate();
	        });
	    }
	},
        recomputed: 
	{
	    seenGetStartedTooltip()
	    {
	        return localStorage.getItem('seenGetStartedTooltip') === 'true';
	    },
	    navItems() : any[] 
	    {
	        console.log('recompute nav');
	        let ret : any[] = [];
	        let _this = this as any;
	        for (var match of this.$route.matched)
	        {
	            for (let mkey in match.instances)
	            {
	                let sub = (match.instances as any)[mkey];
	                if (sub && sub.getEarlyNavItems)
	                {
	                    console.log('Possibly found nav items');
	                    for (let item of sub.getEarlyNavItems())
	                    {
	                        if ((_this.isEmbedded && !item.hiddenInEmbed) || (!_this.isEmbedded && !item.onlyShowInEmbed))
	                        {
	                            ret.push(item);
	                        }
	                    }
	                }
	            }
	        }
	        return ret;
	    },
	    additionalItems() : any[] 
	    {
	        console.log('recompute nav');
	        let ret : any[] = [];
	        let _this = this as any;
	        for (var match of this.$route.matched)
	        {
	            for (let mkey in match.instances)
	            {
	                let sub = (match.instances as any)[mkey];
	                if (sub && sub.getNavItems)
	                {
	                    console.log('Possibly found nav items');
	                    for (let item of sub.getNavItems())
	                    {
	                        if (item.visible && !item.visible()) continue;
	                        if (((_this.isEmbedded && !item.hiddenInEmbed) || (!_this.isEmbedded && !item.onlyShowInEmbed)))
	                        {
	                            ret.push(item);

	                            if(_this.timeline.nodeIDs.length == 0)
	                            {
	                                if(item.text == "Create")
	                                {
	                                    setTimeout(() => 
	                                    {
	                                        this.$root.$emit('bv::show::tooltip', 'get-started-tooltip');
	                                    }, 1500);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return ret;
	    }
	},
        mounted()
        {
            // Implemented this "hack" specifically for embed.  If I understand what's happening internally correctly,
            // I _think_ this should work in the general case as well, but I'm not 100% confident in that.
            // Regardless, leaving this note here in case we have another navbar bug.

            // Note that (if I understand correctly) we need a double tick because the actual page content is a sibling with
            // nested components.  The first tick initializes siblings, the second tick initializes their children.  However
            // it could also just be that, in the specific case of embed, the timeline editor is nested twice.  Or it could
            // be something else entirely.  Doesn't really matter if it works though, and it's certainly better than just throwing
            // in a setTimeout, which I suppose would also work.
            var cb = ()=>
            {
                console.log("Attempting to recompute nav items");
                this.$recompute('navItems');
                this.$recompute('additionalItems');
                this.$forceUpdate();
            };

            this.$nextTick(()=>
            {
                this.$nextTick(cb);
            });

            (window as any).forceRefreshNavbar = cb;
        },
        methods: 
	{
	    supportModalSubmit(modal : BvModalEvent)
	    {
	        modal.preventDefault();
	        this.$nextTick(()=>
	        {
	            (this.$refs['supportForm'] as SupportForm).submit();
	        });
	    },
	    clickDashboard()
	    {
	        if (this.$route.path.includes('/project'))
	        {
	            let _this = this as any;
	            _this.exitProject.text = "Navigating to the dashboard will exit your current project.  Your work will be saved.  Continue?";
	            _this.exitProject.callback = ()=>
	            {
	                this.$router.push('/app/');
	            };
	            (this.$refs.exitProjectModal as any).show();
	            /*setTimeout(() => {
					this.$nextTick(() =>
					{
						(this.$refs.exitProjectText as HTMLElement).focus();
					});
				}, 50);*/
	        }
	        else
	        {
	            this.$router.push('/app/');
	        }
	    },
	    showProfile()
	    {
	        let route = this.$route;
	        if (route.path.includes("/project"))
	        {
	            let _this = this as any;
	            _this.exitProject.text = "Opening your user profile will disconnect you from the current project.  Your work will be saved.  Continue?";
	            _this.exitProject.callback = ()=>
	            {
	                this.$router.push('/app/profile/');
	            };
	            (this.$refs.exitProjectModal as any).show();
	        }
	        else
	        {
	            this.$router.push('/app/profile/');
	        }
	    },
	    logout()
	    {
	        this.$http.post('logout').then(
	            (res) =>
	            {
	                (window as any).Logout(true);
	            },
	            (err) =>
	            {

	            }
	        );
	    },
	    handleDropdownItemClick(click : Function)
	    {
	        click();

	        if (this.$refs.dropdown != null)
	        {
	            for (const d of (this.$refs.dropdown as any))
	            {
	                if (d != null)
	                    d.hide(false);
	            }
	        }
	    },
	    hideTooltip()
	    {
	        this.$root.$emit('bv::hide::tooltip', 'get-started-tooltip');
	        localStorage.setItem('seenGetStartedTooltip', 'true');
	    }
	}
    });
